var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7881 0C5.27365 0 0.788086 4.48556 0.788086 10C0.788086 15.5144 5.27365 20 10.7881 20C16.3025 20 20.7881 15.5144 20.7881 10C20.7881 4.48556 16.3025 0 10.7881 0ZM10.7881 17.5641C6.61972 17.5641 3.2281 14.1724 3.2281 10.0041C3.2281 5.83571 6.61972 2.44408 10.7881 2.44408C14.9564 2.44408 18.3481 5.83571 18.3481 10.0041C18.3481 14.1724 14.9564 17.5641 10.7881 17.5641Z",
    fill: "#ba120e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9649 8.77977H12.0084V5.82328C12.0084 5.14821 11.4634 4.60327 10.7884 4.60327C10.1133 4.60327 9.56836 5.14821 9.56836 5.82328V9.99977C9.56836 10.6748 10.1133 11.2198 10.7884 11.2198H14.9649C15.6399 11.2198 16.1849 10.6748 16.1849 9.99977C16.1849 9.3247 15.6399 8.77977 14.9649 8.77977Z",
    fill: "#ba120e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/f4.5ddc88ca093ef684844fa27764c71838.svg";
export { ForwardRef as ReactComponent };